<template>

	<div class="form_field form_field_input">

		<label class="label" v-if="label" :title="label">
			{{label}}
			<template v-if="label2">
				<br />{{label2}}
			</template>
		</label>

		<div class="value">
			
			<input  
				:type="type"
				lang="de-DE"
				:disabled="disabled"
				class="input-text"
				v-model="value" 
				:inputmode="'decimal'" 
				@blur="blur"
				@focus="focus" />
			
		</div>
		
	</div>
	
</template>

<script>

	import {tf} from "@/functions";

	export default {
		name: "FormInput",
		inject: [
			'trans', 'round'
		],
		props: {
			type: String,
			modelValue: String|Number,	
			label: String,
			label2: String,
			modifier: String|undefined,
			disabled: Boolean
		},
		data() {
			return {
				value: undefined,
				focused: false,
				blur_value: undefined
			}
		},
		computed: {
			 inputmode() {
				 
				 if (this.type === 'number') return 'decimal';
				 else return 'text';
				 
			 }
		},
		components: {},
		methods: {
			blur() {
				
				if (this.value === this.blur_value) return;

				console.log(this.value, parseFloat(this.value), tf(this.value));

				this.$emit('update:modelValue', parseFloat(this.value));
				this.$emit('update');
							
			},
			focus() {
				 
				this.blur_value = this.value;
				this.focused = true;
				
			},
			setValue() {
				
				let n0 = 0;
				
				if (this.modelValue !== null && !isNaN(this.modelValue)) {
					
					let string = this.modelValue.toString();
					let count = false; 
					 
					for (let i = 0; i < string.length; i ++) {
						
						if (count === true) {
							
							if (parseInt(string.charAt(i)) <= 0) {
								
								n0 ++;
								
							} else count = false;
							
						}
						
						if (string.charAt(i) === ',' || string.charAt(i) === '.') {
							
							count = true;
							
						}
						
					}

				}
				
				if (this.modifier === 'ff2') {
										
					if (this.modelValue === null || isNaN(this.modelValue)) this.value = '';
					else this.value = parseFloat(this.modelValue).toFixed(2 + n0);

				} else if (this.modifier === 'ff4') {
					 					
					if (this.modelValue === null || isNaN(this.modelValue)) this.value = '';
					else this.value = parseFloat(this.modelValue).toFixed(4 + n0);
					
				} else if (this.modifier === 'ff5') {
					
					if (this.modelValue === null || isNaN(this.modelValue)) this.value = '';
					else this.value = parseFloat(this.modelValue).toFixed(5 + n0);

				} else if (this.modifier === 'ff0') {
					
					if (this.modelValue === null || isNaN(this.modelValue)) this.value = '';
					else this.value = Math.round(parseFloat(this.modelValue));
					
				} else {
				
					this.value = this.modelValue;
	
				}
				
			}
		},
		mounted() {
			
			this.setValue();
				
		},
		watch: {
			modelValue(newValue) {
				
				this.setValue();
				this.$emit('update');
				
			}
		}
	}

</script>

<style lang="scss">

</style>